import View from './view';

export default View.extend( {

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );

        if (options.collection)
            this.grab( options.collection );
    },

    events: {
        'click .-set-page': function({ currentTarget }) {
            this.trigger( 'page', +currentTarget.dataset.page );
        }
    },

	grab(collection) {
        this.collection = collection;
        // "sync" is full reload from server;
		this.listenTo( collection, 'sync reset', () => 
                this.render() );
    },

    ungrab(collection) {
        this.stopListening( collection );
    },

    serialize() {
        const collection = this.options.collection || this.collection;
        if (!collection)
            return;

        const npages = Math.floor( (collection.total - 1) / collection.limit ) + 1;
        const left = [], middle = [], right = [];

        if (npages > 1)
            left.push( { page: 1 } );

        const lo = Math.max( 2, collection.page - 2 ),
            hi = Math.min( npages - 1, collection.page + 2 );

        for (let i = lo; i <= hi; i++)
            if (lo > 2) 
                middle.push( { page: i } );
            else 
                left.push( { page: i } );

        if (npages > 1)
            if (lo === 2 && hi === npages-1)
                left.push( { page: npages } );
            else if (hi === npages - 1)
                middle.push( { page: npages } );
            else
                right.push( { page: npages } );

        const context = { collection, npages, left, middle, right };

        return context;
    }

} );


// WEBPACK FOOTER //
// ./src/js/view/paging.js